module.exports = __webpack_public_path__ + "static/media/signin-image.79a09580.jpeg";